var React = require('react');

function DashboardNav (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H4zm4 6H6v6h2V8zm1 2h2v4H9v-4zm5-4h-2v8h2V6z","fill":"currentColor"}));
}

DashboardNav.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = DashboardNav;

DashboardNav.default = DashboardNav;
